/**
 * Build a real Error from a media element `error` event.
 * Prefer this over console.error(event), which becomes Sentry
 * "Error: [object Event]" via CaptureConsole.
 */
export function getErrorFromVideoEvent(event: Event): Error {
  const target = event.target as HTMLVideoElement | null;
  const originalTarget =
    (event as Event & { originalTarget?: HTMLVideoElement | null })
      .originalTarget ?? null;
  const pathElement =
    (event as Event & { path?: Array<HTMLVideoElement | null> }).path?.[0] ??
    null;

  const mediaError =
    target?.error ?? originalTarget?.error ?? pathElement?.error;

  return mediaError
    ? new Error(`Video error: ${mediaError.message} (code: ${mediaError.code})`)
    : new Error("Unknown video error (could not be captured)");
}
